import React from 'react';
import { Camera } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import AdminPhotoUploader from './AdminPhotoUploader';

/* "Add photos" from a job card (admins / supervisors) — Nov 2026. */
export default function AdminPhotoDialog({ job, open, onClose, token, users, onUploaded }) {
  if (!job) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose?.(); }}>
      <DialogContent className="max-w-[95vw] sm:max-w-xl" data-testid="admin-photo-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg"><Camera className="w-5 h-5 text-[#1E88E5]" /> Add photos to this job</DialogTitle>
          <DialogDescription className="text-sm">
            <span className="text-slate-200 font-medium">{job.job_number ? `#${job.job_number} · ` : ''}{job.title}</span>
            {job.customer_name ? <span className="text-slate-400"> — {job.customer_name}</span> : null}
            <span className="block mt-1 text-slate-400">For photos a worker texted or emailed you, or saved on their phone with no signal on site.</span>
          </DialogDescription>
        </DialogHeader>
        <AdminPhotoUploader job={job} token={token} users={users} onUploaded={onUploaded} />
      </DialogContent>
    </Dialog>
  );
}
